import * as React from 'react';
import { observer } from 'mobx-react';
import { Col, Row } from 'antd';

import { BooleanView } from 'src/core/ui/boolean.view';
import { SearchTransferView } from './requests/search-transfer.view';
import { SearchAccommodationView } from './requests/search-accommodation.view';
import { SearchGeneralView } from './requests/search-general.view';
import { SearchCarRentView } from './requests/search-car-rent.view';
import { SearchFlightView } from './requests/search-flight.view';
import { SearchOccupancyView } from './search-occupancy.view';
import { SearchTourView } from 'src/app/bookings/search/requests/search-tour.view';

interface SearchProps {
	paxs: PersonOccupancy[];
	currentSearch: Search;
	fieldsTaxonomy: TaxonomicField[];
	onChangeCategory: (productCategoryId?: number) => Promise<void>;
	setBusy(isBusy: boolean);
}

@observer
export class SearchView extends React.Component<SearchProps, {}> {
	private renderOccupancy(): React.ReactNode {
		return (
			<SearchOccupancyView
				type={this.props.currentSearch.type}
				occupancies={this.props.currentSearch.occupancies}
				setBusy={this.props.setBusy}
				paxs={this.props.paxs}
				lockUnits={this.props.currentSearch.type === "Tour"}
			/>
		);
	}

	private renderApis(): React.ReactNode {
		let apis = [];
		for (let api of this.props.currentSearch.apiNames) {
			if (api.isActiveForApi) {
				apis.push(
					<div key={api.name} style={{ display: "inline-block" }} className="mr-1">
						<BooleanView
							mode="edit"
							label={api.name}
							value={api.isActive}
							onChanged={newVal => {
								api.isActive = newVal;
							}}
						/>
					</div>
				);
			}
		}

		return apis;
	}

	render(): React.ReactNode {
		const { currentSearch, setBusy, fieldsTaxonomy, onChangeCategory } = this.props;
		if (currentSearch == null) {
			return null;
		}

		const props = {
			setBusy,
			fieldsTaxonomy,
			onChangeCategory
		};

		let view: any;
		switch (currentSearch.type) {
			case 'Accommodation':
				view = (
					<SearchAccommodationView
						currentSearch={currentSearch as SearchAccommodation}
						{...props}
					/>
				);
				break;
			case 'CarRent':
				view = (
					<SearchCarRentView
						currentSearch={currentSearch as SearchCarRent}
						{...props}
					/>
				);
				break;
			case 'Transfer':
				view = (
					<SearchTransferView
						currentSearch={currentSearch as SearchTransfer}
						{...props}
					/>
				);
				break;
			case 'General':
				view = (
					<SearchGeneralView
						currentSearch={currentSearch as SearchGeneral}
						{...props}
					/>
				);
				break;
			case 'Flights':
				view = (
					<SearchFlightView
						currentSearch={currentSearch as SearchFlight}
						{...props}
					/>
				);
				break;
			case 'Tour':
				view = (
					<SearchTourView
						currentSearch={currentSearch as SearchTour}
						{...props}
					/>
				);
				break;
		}

		return (
			<React.Fragment>
				{view}
				<Row>
					{this.renderApis()}
				</Row>
				<Row>
					<Col xs={24}>
						{this.renderOccupancy()}
					</Col>
				</Row>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/search/search.view.tsx